import { z } from 'zod';
export const createLeadSchema = z.object({
    name: z.string().min(1).max(200).transform((s) => s.replace(/<[^>]*>/g, '').trim()),
    email: z.string().email().max(254).transform((s) => s.toLowerCase().trim()),
    phone: z.string().max(20).optional().transform((s) => s?.replace(/[^\d+]/g, '')),
    source_page: z.string().max(500).refine(s => s.startsWith('/') || s.startsWith('http://') || s.startsWith('https://'), 'Must be a URL or path'),
    location_id: z.string().uuid(),
    crm_tags: z.array(z.string().max(50).regex(/^[\w\s\-./]+$/, 'Tags may only contain letters, numbers, spaces, hyphens, dots, and slashes')).max(10).optional().default([]),
    recaptcha_token: z.string().min(1),
    utm_source: z.string().max(200).optional(),
    utm_medium: z.string().max(200).optional(),
    utm_campaign: z.string().max(200).optional(),
    utm_term: z.string().max(200).optional(),
    utm_content: z.string().max(200).optional(),
});
export const leadResponseSchema = z.object({
    id: z.string().uuid(),
    status: z.string(),
    created_at: z.string().datetime(),
});
export const leadQuerySchema = z.object({
    cursor: z.string().uuid().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    date_from: z.string().datetime().optional(),
    date_to: z.string().datetime().optional(),
    search: z.string().max(200).optional(),
    location_id: z.string().uuid().optional(),
});
export const updateLeadStatusSchema = z.object({
    status: z.enum(['new', 'contacted', 'trial_booked', 'trial_completed', 'enrolled', 'lost']),
    notes: z.string().max(1000).optional(),
});
//# sourceMappingURL=lead.js.map